module.exports = __webpack_public_path__ + "ed73d5226.png";